import 'css-chunksrc/client/scenes/resourceEdition/assignCostProfileToResource/costProfiles/styles.scss';export default {
  "costProfiles": "_costProfiles_mwe7m_1",
  "costProfile": "_costProfile_mwe7m_1",
  "selected": "_selected_mwe7m_20",
  "search": "_search_mwe7m_24",
  "input": "_input_mwe7m_28"
};